/**
 * Parse the data uri string and return the uri value without the uri type
 *
 * Usage:
 * const uri = 'tel://12121112222';
 * const dataURI = parseURI(uri);
 * if (dataURI.type === 'tel') {
 *   console.log(dataURI.value);
 * }
 *
 * @param {string} uri - full string of the uri including the type and the value
 *
 * @returns the uri value
 */
const parseURI = uri => {
  const [uriType, uriValue] = uri.split('://');
  return {
    type: uriType,
    value: uriValue,
  };
};

export default parseURI;
